import { useQuery } from '@tanstack/react-query';

import { queries } from '~modules/media-library/controller/api/Queries';
import { type AssetId } from '~modules/media-library/model/Asset';
import { RaiseRequestForm } from '~modules/media-library/view/RaiseRequestForm/RaiseRequestForm';

type RaiseRequestControllerProps = {
  assetId: AssetId;
  onClose?: () => void;
};

export function RaiseRequestController({ assetId, onClose }: RaiseRequestControllerProps) {
  // load form settings
  const { data: formSettings } = useQuery({
    ...queries.mediaLibrary.raiseRequestFormFields(assetId),
    enabled: Boolean(assetId),
    refetchOnWindowFocus: false,
  });

  if (Boolean(formSettings)) {
    return <RaiseRequestForm assetId={assetId} formSettings={formSettings} onClose={onClose} />;
  } else {
    return null;
  }
}
